.b1{justify-content:flex-end;}